import React from "react";

const Success = ({ message }) => {
  return <div className="success">{message}</div>;
};

export default Success;
